(function ($) {
  'use strict';

  var $stickyMenuToggle = $('.sticky-widget__toggle'),
    $stickyMenu = $('.sticky-widget__list'),
    $stickyShareToggle = $('.js-sticky-widget-share'),
    $stickyShare = $('.sticky-widget__popout-wrapper');

  $stickyMenuToggle.on('click', function () {
    $stickyMenu.toggleClass('active');
  });

  $stickyShareToggle.on('click', function () {
    $stickyShareToggle.toggleClass('active');
    $stickyShare.toggleClass('active');
  });
}(jQuery));